module.exports = __webpack_public_path__ + "assets/RetinaNarr-Light.24c68ac27c209da5c83d10b3038c17af.woff2";